import script from "./SovaClubHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./SovaClubHeader.vue?vue&type=script&setup=true&lang=ts"

import "./SovaClubHeader.vue?vue&type=style&index=0&id=7d2f9a34&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d2f9a34"]])

export default __exports__